import type React from "react";
import { useLayoutEffect, useState } from "react";

const useElementRect = (containerRef: React.RefObject<HTMLElement>): DOMRect | undefined => {
  const [rect, setRect] = useState<DOMRect>();

  useLayoutEffect(() => {
    const domElement = containerRef.current;

    if (!domElement) return undefined;

    const updateRect = () => {
      if (domElement) {
        setRect(domElement.getBoundingClientRect());
      }
    };

    updateRect();

    if (typeof window.ResizeObserver === "function") {
      const resizeObserver = new ResizeObserver(updateRect);
      resizeObserver.observe(domElement);
      return () => resizeObserver.unobserve(domElement);
    } else {
      // on-resize on non supporting browsers: we listen to the whole window
      window.addEventListener("resize", updateRect);
      return () => window.removeEventListener("resize", updateRect);
    }
  }, [containerRef, setRect]);

  return rect;
};

export default useElementRect;
